var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "AKxYR5 VZYmYf comp-m69434ay3",
    "data-testid": "svgRoot-comp-m69434ay3__item-ker6vn3g"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-bbox": "30 30 140 140",
    "data-type": "color",
    viewBox: "30 30 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-m69434ay3__item-ker6vn3g svg [data-color=&quot;1&quot;]{fill:#1d0e03}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c108ab",
    d: "M97.5 96.1c27.4 0 51.4 15 64.1 37.2 5.3-10 8.4-21.2 8.4-33.3 0-38.6-31.4-70-70.1-70S30 61.4 30 100c0 10.3 2.3 20.1 6.3 28.8C49.4 109.2 72 96.1 97.5 96.1z",
    "data-color": 1,
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c108ab",
    d: "M97.5 105.8c25.5 0 47.8 12.9 61.2 32.3 1-1.6 2.1-3.2 2.9-5C148.8 110.9 124.8 96 97.5 96c-25.6 0-48 12.9-61.4 32.7.8 1.9 1.8 3.9 2.9 5.6 13.5-17.2 34.8-28.5 58.5-28.5z",
    "data-color": 1,
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c108ab",
    d: "M97.5 105.8c-23.8 0-44.9 11.3-58.5 28.6 1.3 2.3 2.6 4.3 4.2 6.4 12.9-15.8 32.4-25.7 54.3-25.7 23.4 0 44.1 11.4 56.9 29.1 1.6-1.9 3.1-3.9 4.3-6-13.2-19.5-35.8-32.4-61.2-32.4z",
    "data-color": 1,
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c108ab",
    d: "M97.5 115.3c-21.9 0-41.4 10-54.3 25.7 1.1 1.6 2.4 3.2 3.7 4.7 12.9-13.2 30.8-21.6 50.6-21.6 21.3 0 40.3 9.5 53.2 24.3 1.3-1.3 2.6-2.7 3.7-4.2-12.8-17.5-33.4-28.9-56.9-28.9z",
    "data-color": 1,
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c108ab",
    d: "M97.5 124.1c-19.8 0-37.9 8.2-50.6 21.6C59.8 160.5 78.8 170 100 170c19.8 0 37.9-8.2 50.6-21.6-12.9-14.8-31.9-24.3-53.1-24.3z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.1b6dc04b0530374226063a6988853eea.svg";
export { ForwardRef as ReactComponent };